// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Footer_wrapper__2AMk0","logos":"Footer_logos__3xRD3","logo":"Footer_logo__2RVT_"};